import { render } from "./dashboardLayout.vue?vue&type=template&id=4a7430a6&scoped=true&ts=true&lang=pug"
import script from "./dashboardLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./dashboardLayout.vue?vue&type=script&lang=ts&setup=true"

import "./dashboardLayout.vue?vue&type=style&index=0&id=4a7430a6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7430a6"]])

export default __exports__